<template>
  <div class="container-xxl-fluid" @scroll="handleScroll" v-if="showReport" >
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4">
            <search-select
                :search-type="'current'"
                @itemChange="(e) => (dashboardFilterCurrentCode = e)"
                :placeholder="'Tüm Cariler'"
            >
            </search-select>
          </div>
          <div class="col-lg-4">
            <v-select
                v-model="dashboardFilterSalesPersonCode"
                placeholder="Tüm Plasiyerler"
                clearable
                solo
                dense
                filled
                :items="salesPersonList"
                :item-text="item => item.name"
                :item-value="item => item.code"
            >
            </v-select>
          </div>
          <div class="col-lg-4">
            <v-select
                v-model="dashboardFilterReportDbName"
                placeholder="Tüm Şirketler"
                clearable
                solo
                filled
                dense
                :items="companyList"
                :item-text="item => item.name"
                :item-value="item => item.name"
            >
            </v-select>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <ReportCompanyDataContainer
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></ReportCompanyDataContainer>
      </div>

<!--      <div class="col-lg-12 d-flex flex-column">-->
<!--        <CariYaslandirma-->
<!--            style="flex-grow: 1;-->
<!--            display: flex;"-->
<!--            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"-->
<!--            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"-->
<!--            :dashboard-filter-sales-person-code-prop="-->
<!--            dashboardFilterSalesPersonCode-->
<!--          "-->
<!--        ></CariYaslandirma>-->
<!--      </div>-->

      <div class="col-lg-6 d-flex flex-column">
        <AylikCiroGrafigi
            style="flex-grow: 1;
             display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></AylikCiroGrafigi>
      </div>

      <div class="col-lg-6 d-flex flex-column">
        <EnIyiSatis
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></EnIyiSatis>
      </div>
      <div class="d-flex flex-column align-items-center mt-15 " v-if="!this.loadMore">
        <div class="h4">
          Daha Fazlası İçin Kaydırın <div class="container">
          <div class="field d-flex flex-column align-items-center">
            <div class="scroll"></div>
          </div>
        </div>
        </div>
      </div>

      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <SatisFaturasiRaporu
            style="flex-grow: 1;
              display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></SatisFaturasiRaporu>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <AlisFaturasiRaporu
            style="flex-grow: 1;
             display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></AlisFaturasiRaporu>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <SatisIrsaliyesiRaporu
            style="flex-grow: 1;
              display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></SatisIrsaliyesiRaporu>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <AlisIrsaliyesiRaporu
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></AlisIrsaliyesiRaporu>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <MusteriCekleri
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></MusteriCekleri>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <MusteriSenetleri
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></MusteriSenetleri>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <BorcCekleri
            style="flex-grow: 1;
              display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></BorcCekleri>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <BorcSenetleri
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></BorcSenetleri>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <Top10BorcluCariListesi
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></Top10BorcluCariListesi>
      </div>
      <div class="col-lg-6 d-flex flex-column" v-if="this.loadMore">
        <Top10AlacakliCariListesi
            style="flex-grow: 1;
            display: flex;"
            :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
            :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
            :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
        ></Top10AlacakliCariListesi>
      </div>
    </div>
    <div class="row pt-3 pb-3" v-if="this.loadMore">
      <EnIyiSatilanUrunler
          :title="'En İyi Satılan Ürünler'"
          :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
          :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
          :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
          :view-type="'table'"
      ></EnIyiSatilanUrunler>
    </div>
    <div class="row pt-3 pb-3" v-if="this.loadMore">
      <PlasiyerTahsilatAnaliz
          :title="'Plasiyer Tahsilat Analiz'"
          :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
          :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
          :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
      ></PlasiyerTahsilatAnaliz>
    </div>

    <div class="row pt-3 pb-3" v-if="this.loadMore && !this.dashboardFilterSalesPersonCode">
      <PlasiyerTahsilatAnalizGrafigi></PlasiyerTahsilatAnalizGrafigi>
    </div>

    <div class="row pt-3 pb-3" v-if="this.loadMore">
      <PlasiyerTahsilatAnalizDetay
          :title="'Plasiyer Tahsilat Analiz Detay'"
          :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
          :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
          :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
      ></PlasiyerTahsilatAnalizDetay>
    </div>


    <div class="row pt-3 pb-3" v-if="this.loadMore">
      <GiderRaporu
          :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"
          :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"
          :dashboard-filter-sales-person-code-prop="
            dashboardFilterSalesPersonCode
          "
      ></GiderRaporu>
    </div>
    <!--    <div class="row pt-3 pb-3" v-if="this.loadMore">-->
    <!--      <BankaListesi-->
    <!--          :dashboard-filter-current-code-prop="dashboardFilterCurrentCode"-->
    <!--          :dashboard-filter-report-db-name-prop="dashboardFilterReportDbName"-->
    <!--          :dashboard-filter-sales-person-code-prop="-->
    <!--            dashboardFilterSalesPersonCode-->
    <!--          "-->
    <!--      ></BankaListesi>-->
    <!--    </div>-->
  </div>

</template>

<script>
import ReportCompanyDataContainer from "@/components/dashboard/containers/ReportCompanyDataContainer";
import AylikCiroGrafigi from "@/components/dashboard/AylikCiroGrafigi/AylikCiroGrafigi";
import EnIyiSatis from "@/components/dashboard/EnIyiSatis/EnIyiSatis";
import SatisFaturasiRaporu from "@/components/dashboard/SatisFaturasiRaporu/SatisFaturasiRaporu";
import AlisFaturasiRaporu from "@/components/dashboard/AlisFaturasiRaporu/AlisFaturasiRaporu";
import SatisIrsaliyesiRaporu from "@/components/dashboard/SatisIrsaliyesiRaporu/SatisIrsaliyesiRaporu";
import AlisIrsaliyesiRaporu from "@/components/dashboard/AlisIrsaliyesiRaporu/AlisIrsaliyesiRaporu";
import MusteriCekleri from "@/components/dashboard/MusteriCekleri/MusteriCekleri";
import MusteriSenetleri from "@/components/dashboard/MusteriSenetleri/MusteriSenetleri";
import BorcCekleri from "@/components/dashboard/BorcCekleri/BorcCekleri";
import BorcSenetleri from "@/components/dashboard/BorcSenetleri/BorcSenetleri";
import Top10BorcluCariListesi from "@/components/dashboard/Top10BorcluCariListesi/Top10BorcluCariListesi";
import Top10AlacakliCariListesi from "@/components/dashboard/Top10AlacakliCariListesi/Top10AlacakliCariListesi";
import EnIyiSatilanUrunler from "@/components/dashboard/EnIyiSatilanUrunler/EnIyiSatilanUrunler";
import PlasiyerTahsilatAnaliz from "@/components/dashboard/PlasiyerTahsilatAnaliz/PlasiyerTahsilatAnaliz";
import GiderRaporu from "@/components/dashboard/GiderRaporu/GiderRaporu";
import PlasiyerTahsilatAnalizDetay
  from "@/components/dashboard/PlasiyerTahsilatAnalizDetay/PlasiyerTahsilatAnalizDetay";
import {mapActions, mapState} from "vuex";
import SearchSelect from "@/components/searchSelect.vue";
// import CariYaslandirma from "@/components/dashboard/CariYaslandirma/CariYaslandirma.vue";
import PlasiyerTahsilatAnalizGrafigi
  from "@/components/dashboard/PlasiyerTahsilatAnaliz/PlasiyerTahsilatAnalizGrafigi.vue";
// import PlasiyerTahsilatAnalizGrafigi
//   from "@/components/dashboard/PlasiyerTahsilatAnaliz/PlasiyerTahsilatAnalizGrafigi.vue";

export default {
  components: {
    PlasiyerTahsilatAnalizGrafigi,
    // PlasiyerTahsilatAnalizGrafigi,
    // CariYaslandirma,
    SearchSelect,
    ReportCompanyDataContainer,
    AylikCiroGrafigi,
    EnIyiSatis,
    SatisFaturasiRaporu,
    AlisFaturasiRaporu,
    SatisIrsaliyesiRaporu,
    AlisIrsaliyesiRaporu,
    MusteriCekleri,
    MusteriSenetleri,
    BorcCekleri,
    BorcSenetleri,
    Top10BorcluCariListesi,
    Top10AlacakliCariListesi,
    EnIyiSatilanUrunler,
    PlasiyerTahsilatAnaliz,
    GiderRaporu,
    PlasiyerTahsilatAnalizDetay
  },
  mounted() {
    this.fetchSalesPersonList({
      params: {},
      body: {}
    });
    this.fetchCompanyList({
      params: {},
      body: {}
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
    ...mapState("company", ["companyList"]),
    ...mapState("dashboard",["salespersonSalePaymentDataLoading"]),
    showReport() {
      return this.user.ShowReport === 1 || this.user.ShowReport === "1";
    },
  },
  created() {
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      dashboardFilterSalesPersonCode: null,
      dashboardFilterReportDbName: null,
      dashboardFilterCurrentCode: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      loadMore: false,
      scrollPercentage: null,
      filteredOptions: null,
      searchTerm: "",
    };
  },
  methods: {
    ...mapActions("current", ["fetchSalesPersonList", "fetchCurrentList"]),
    ...mapActions("company", ["fetchCompanyList"]),
    handleScroll() {
      if (this.loadMore === false) {
        this.scrollPercentage = (window.pageYOffset / this.$el.scrollHeight) * 100;
        if (this.scrollPercentage > 10) {
          this.loadMore = true;
          window.removeEventListener("scroll", this.handleScroll);
        }
      }
    }

  },
};
</script>

<style>

.scroll {
  width: 60px;
  height: 60px;
  border: 2px solid #333;
  border-radius: 50%;
  position: relative;
  animation: down 1.5s infinite;
  -webkit-animation: down 1.5s infinite;
  &::before {
    content: '';
    position: absolute;
    top: 15px;
    left: 18px;
    width: 18px;
    height: 18px;
    border-left: 2px solid #333;
    border-bottom: 2px solid #333;
    transform: rotate(-45deg);
  }
}

@keyframes down {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translateY(15px);
  }
  40% {
    transform: translate(0);
  }
}
</style>
